export enum Pagination {
  TAKE = 10,
}
